import tracker from "sa-sdk-javascript";
import { ClientInfo } from "./clientHelper";
import { isDebug } from "./logHelper";
/**
 * 按照运行终端去埋公共属性
 * @param commonProps 公共属性
 */
const setTrackPublicProperty = commonProps => {
  let pub_platform, pub_product_line;
  switch (true) {
    case ClientInfo.isAvatrApp:
      pub_platform = ClientInfo.isIos ? "iOS" : ClientInfo.isAndroid ? "Android" : "Harmony";
      pub_product_line = "C-Avatr-APP";
      break;
    case ClientInfo.isWeApp:
      pub_platform = "微信小程序";
      pub_product_line = "C-Avatr-MA";
      break;
    case ClientInfo.isBaiduApp:
      pub_platform = "百度小程序";
      pub_product_line = "C-Avatr-MA";
      break;
    default:
      pub_platform = "Web";
      pub_product_line = "C-Avatr-H5";
      break;
  }
  tracker.registerPage(Object.assign({
    pub_platform,
    pub_product_line
  }, commonProps));
};
/**
 * 初始化埋点SDK(全埋点, 无差别收集日志)
 * 访问url的search中包含字符 "avatr_track=debug" 可以在console框查看日志
 * 文档: https://wiki.avatr.com/pages/viewpage.action?pageId=45585491
 * @param serverUrl 上报地址
 * @param commonProps 项目通用属性
 * @param userId 用户id
 */
export const init = (serverUrl, commonProps, userId) => {
  const show_log = /avatr_track=debug/.test(window.location.search) || isDebug();
  //1:注册PageLeave事件, 开启$WebPageLeave
  tracker.use("PageLeave", {});
  //2:初始化配置
  tracker.init({
    server_url: serverUrl,
    is_track_single_page: true,
    use_client_time: true,
    send_type: "beacon",
    show_log,
    heatmap: {
      //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
      clickmap: "default",
      //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
      scroll_notice_map: "default"
    }
  });
  //3:根据业务要求，添加相关公共属性
  setTrackPublicProperty(commonProps || {});
  //4:设置之后，SDK 就会自动收集页面浏览事件$pageview，以及设置初始来源。
  tracker.quick("autoTrack");
  //5:关联用户
  userId && login(userId);
};
/**
 * 自定义埋点, 对指定操作收集信息
 * 文档: https://wiki.avatr.com/pages/viewpage.action?pageId=45585491
 * @param eventCode 事件代码: 该字段需要提前在神策管理后台添加, 否则无法收集
 * @param customProps 自定义埋点属性
 */
export const track = (eventCode, customProps) => {
  tracker.track(eventCode, customProps);
};
/**
 * 关联用户
 * @param userId 登录用户的id
 */
export const login = userId => {
  tracker.login(userId);
};
/**
 * 取消关联用户(库中仅提供方法支持, 已和产品确定过, 实际业务中不应调用)
 */
export const logout = () => {
  tracker.logout();
};